const state = {
  navbarStatus: 'black'
}

const mutations = {
  SET_NAVBAR_STATUS: (state, navbarStatus) => {
    state.navbarStatus = navbarStatus
  }
}

const actions = {
  setNavbarStatus({ commit }, data) {
    commit('SET_NAVBAR_STATUS',data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
